import React from "react";
import {
  FaLeaf,
  FaBook,
  FaWalking,
  FaPaperPlane,
  FaLightbulb,
  FaStar,
} from "react-icons/fa";

import "./IconStrip.css";

function IconStrip() {
  return (
    <div className="icon-strip">
      <div className="icon-strip-inner">
        <span className="icon-group">
          <FaLeaf size={24} className="icon-strip-icon" />
          <strong>Shell</strong>
        </span>
        <span className="icon-group">
          <FaBook size={24} className="icon-strip-icon" />
        </span>
        <span className="icon-group">
          <FaWalking size={24} className="icon-strip-icon" />
        </span>
        <span className="icon-group">
          <FaPaperPlane size={24} className="icon-strip-icon" />
        </span>
        <span className="icon-group">
          <FaLightbulb size={24} className="icon-strip-icon" />
        </span>
        <span className="icon-group">
          <FaStar size={24} className="icon-strip-icon" />
          <strong>Ferrari</strong>
        </span>
      </div>
    </div>
  );
}

export default IconStrip;
